import {
	Box,
	Button,
	Flex,
	FormControl,
	FormLabel,
	Grid,
	GridItem,
	Heading,
	Image,
	Input,
	Text,
	Textarea,
	useDisclosure,
	useToast,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useRef, useState } from "react";
import CustomSpinner from "../Spinner/CustomSpinner";

const SubmitPropertyForm5 = (props) => {
	const {
		register,
		errors,
		uploadedFiles,
		setUploadedFiles,
		fields,
		handleAddMore,
		handleRemove,
	} = props;
	const toast = useToast();
	const token = sessionStorage.getItem("token");
	const [selectedFile, setSelectedFile] = useState();
	const inputRef = useRef(null);
	const { isOpen, onOpen, onClose } = useDisclosure();
	const allowedFileTypes = [
		"image/jpg",
		"image/gif",
		"image/png",
		"image/jpeg",
	];
	const [forceRender, setForceRender] = useState(false);

	const handleChangeFile = async (e, index) => {
		if (e.target.files[0]) {
			if (allowedFileTypes.includes(e.target.files[0].type)) {
				console.log("File uploaded is: ", e.target.files);
				setSelectedFile(e.target.files[0]);
				let tempUploadedFiles = uploadedFiles;
				tempUploadedFiles[index].error = null;
				setUploadedFiles(tempUploadedFiles);
			} else {
				let tempUploadedFiles = uploadedFiles;
				tempUploadedFiles[index].error = "Only images are allowed";
				// console.log("temp uploaded files: ", tempUploadedFiles);
				setUploadedFiles(tempUploadedFiles);
				setForceRender(!forceRender);
			}
		}
	};

	const handleUploadFile = async (e, index) => {
		if (!uploadedFiles[index].error) {
			if (selectedFile) {
				onOpen();
				const formData = new FormData();
				formData.append("files", selectedFile);
				await axios
					.post(
						"https://asset-tokenization-liart.vercel.app/s3/upload",
						formData,
						{
							headers: {
								Authorization: `Bearer ${token}`,
							},
						}
					)
					.then((response) => {
						console.log(
							"Response from getting picture upload data: ",
							response
						);
						setSelectedFile();
						inputRef.current.value = null;
						let tempUploadedFiles = uploadedFiles;
						tempUploadedFiles[index].file = response.data[0];
						tempUploadedFiles[index].error = null;
						setUploadedFiles(tempUploadedFiles);
						onClose();
					})
					.catch((error) => {
						console.log("Error from getting picture upload data: ", error);
						toast({
							title: "Error occured",
							description: error?.response?.data?.message,
							status: "error",
							duration: 4000,
							isClosable: true,
							position: "bottom-left",
						});
						let tempUploadedFiles = uploadedFiles;
						tempUploadedFiles[index].error = "Error in file";
						setUploadedFiles(tempUploadedFiles);
						onClose();
					});
			} else {
				let tempUploadedFiles = uploadedFiles;
				tempUploadedFiles[index].error = "Select a file to upload";
				tempUploadedFiles[index].file = null;
				setUploadedFiles(tempUploadedFiles);
				setForceRender(!forceRender);
			}
		}
	};

	return (
		<>
			<Heading w="100%" textAlign={"center"} fontWeight="normal" mb="2%">
				Sponsors
			</Heading>

			{fields.map((item, index) => (
				<Box key={item.id} mt="5%">
					<FormControl mt="2%">
						<FormLabel htmlFor="name" fontWeight={"normal"}>
							Name
						</FormLabel>
						<Input
							id="name"
							placeholder="Name"
							{...register(`sponsors[${index}].sponsorName`, {
								required: "Name is required",
							})}
						/>
						{errors.sponsors && (
							<Text color="red">
								{errors.sponsors[index]?.sponsorName?.message}
							</Text>
						)}
					</FormControl>

					<FormControl>
						<FormLabel htmlFor="description" fontWeight={"normal"} mt="2%">
							Description
						</FormLabel>
						<Textarea
							rows={4}
							pr="4.5rem"
							placeholder="description"
							{...register(`sponsors[${index}].sponsorDescription`, {
								required: "Description is required",
							})}
						/>
						{errors.sponsors && (
							<Text color="red">
								{errors.sponsors[index]?.sponsorDescription?.message}
							</Text>
						)}
					</FormControl>

					<FormControl mt="2%">
						<FormLabel>Image</FormLabel>
						<Grid templateColumns={"repeat(2, 1fr)"} gap={5}>
							<GridItem colSpan={{ base: 2, lg: 1 }}>
								<Input
									type="file"
									border="none"
									padding="0px"
									borderRadius="0px"
									ref={inputRef}
									onChange={(e) => handleChangeFile(e, index)}
									accept={allowedFileTypes.join(",")}
								/>
								{uploadedFiles[index]?.error && (
									<Text color="red">{uploadedFiles[index]?.error}</Text>
								)}
							</GridItem>

							<GridItem
								colSpan={{ base: 2, lg: 1 }}
								display={"flex"}
								justifyContent={{ base: "flex-start", lg: "flex-end" }}
							>
								<Button
									onClick={(e) => handleUploadFile(e, index)}
									bgColor="#002B5B"
									color="white"
									_hover={{
										bgColor: "#1C3E64",
									}}
									mb="7px"
									size="sm"
								>
									Upload File
								</Button>
							</GridItem>
						</Grid>
						<br />
						{uploadedFiles[index]?.file && (
							<a href={uploadedFiles[index].file} target="_blank">
								<Flex alignItems="center" gap="5px" mb="15px">
									<Image
										src={uploadedFiles[index].file}
										alt="Image"
										w="100px"
										h="100px"
										minW="100px"
									/>
								</Flex>
							</a>
						)}
					</FormControl>

					<Flex justifyContent="space-between" alignItems="center">
						<Button onClick={() => handleRemove(index)} color="#315B84">
							Remove
						</Button>
						{fields.length - 1 === index ? (
							<Button onClick={handleAddMore} color="#315B84">
								Add More
							</Button>
						) : null}
					</Flex>
				</Box>
			))}
			<CustomSpinner isSpinnerOpen={isOpen} />
		</>
	);
};

export default SubmitPropertyForm5;
